import { inventoryCategoryService } from "../../../../../Api/Services/InventoryService/inventoryCategory";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IEditInventoryCategoryResponse } from "../../types";


export const getEditInventoryCategoryThunk = createServiceAsyncThunk<
  IEditInventoryCategoryResponse,
  number
>(
  ACTION_NAMES.EDIT_INVENTORY_CATEGORY,
  (id) => inventoryCategoryService.getEditInventoryCategory(id),
  ERROR_MESSAGES.EDIT_INVENTORY_CATEGORY_FAILURE 
);


// Slice
const editInventoryCategorySlice = createGenericSlice<
  IEditInventoryCategoryResponse,
  number
>(
  SLICE_NAMES.EDIT_INVENTORY_CATEGORY_SLICE, 
  getEditInventoryCategoryThunk
);


// Actions
export const {
    clearError: clearEditInventoryCategoryError,
    clearSuccessMessage: clearEditInventoryCategorySuccess,
} = editInventoryCategorySlice.actions;

export default editInventoryCategorySlice.reducer;